/* eslint-disable */
import { mapGetters } from "vuex";
import mixins from '@/mixins/mixins';
import dateMixin from '@/mixins/date';
import _ from 'lodash';


export default {
  mixins:[mixins, dateMixin],
  computed: {
    ...mapGetters([
      'get_shipment_editing_mode',
      'get_editing_shipment',
      'get_booking_systems',
    ]),
  },
  created() {
    //Display errors must be in created hook, message must be initiated in at component create
    if(this.get_shipment_editing_mode && this.get_editing_shipment.errorStatuses.length > 0){
      let message = '<div>';
      this.get_editing_shipment.errorStatuses.forEach((error) => {
        const agentName = (this.get_editing_shipment.shippingAgentName && parseInt(error.status_id) === 36)
          ? `${this.get_editing_shipment.shippingAgentName} :` : '';
        message += `${agentName} ${error.message}</br>`;
      })
      message += '</div>';

      if (this.get_editing_shipment.shipmentType === 'draft') {
        this.draftError = message
      } else {
        // this.$store.commit('SHOW_NOTIFICATION_BAR', {
        //   message: message,
        //   type: 'alert-window',
        // });
      }
    }
  },
  mounted() {
    if( this.get_shipment_editing_mode ){
      this.draftShippmentId = this.get_editing_shipment.draftShippmentId;
      // PLACE DATA FROM EDITING OBJECT

      const editingShipmentDate = this.get_editing_shipment?.shippingDate;
      if (this.isDateInFuture(editingShipmentDate)) {
        this.setShippingDate(this.parseUnknownDate(editingShipmentDate).toFormat('yyyy-MM-dd'))
      } else {

        this.setShippingDate(this.getFirstFiveAvailableShippingDates[0].toFormat('yyyy-MM-dd'));
      }

      this.useContentOnShipmentLevel = this.get_editing_shipment.useContentOnShipmentLevel;
      this.senderHandlingType        = this.get_editing_shipment.senderHandlingType;
      this.shipperType               = this.get_editing_shipment.fromData.company ? 'company' : 'private';
      this.receiverType              = this.get_editing_shipment.toData.company ? 'company' : 'private';

      // Set shipper
      this.$store.dispatch('GET_SHIPPERS', { type: [1, 2] }).then((res) => {
        this.shipperOptions = [
          {value: null, text: 'Other address', country: ''},
          ...res.filter((opt) => {
            const type = Array.isArray(opt.type) ? opt.type : (opt.type ? JSON.parse(opt.type) : []);
            const hasType1 = type.indexOf('1') !== -1 || type.indexOf(1) !== -1;
            const hasType2 = type.indexOf('2') !== -1 || type.indexOf(2) !== -1;
            return hasType1 || hasType2;
          }).map((opt) => {
            return {
              value: opt.id,
              country: opt.country_id ? this.getCountry(opt.country_id, 'alpha2') : '',
              text: `
                ${opt.company_name ? opt.company_name + ', ' : ''}
                ${opt.name ? opt.name + ', ' : ''}
                ${opt.address_1 ? opt.address_1 + ', ' : ''}
                ${opt.post_code ? opt.post_code + ', ' : ''}
                ${opt.city ? opt.city + ', ' : ''}
                ${opt.state ? opt.state + ', ' : ''}
                ${opt.country_id ? this.getCountry(opt.country_id, 'name') : ''}
              `
            };
          }),
        ];
        this.shipper = this.get_editing_shipment.shipper;
        this.foreignShipper = this.get_editing_shipment.foreignShipper;
        if(this.get_editing_shipment.fromAddress.address_1 === '' && this.get_user.sender_id){
          this.shipper = this.get_user.sender_id;
          this.isShipperInFrom = true;
          this.changeAddress('from', {...res.filter(opt => opt.id === this.shipper)[0], typeOfAction: 'app'});
          this.foreignShipper = false;
        }
      });
      // Set customer - from
      if (this.get_editing_shipment.fromAddress.address_1 !== '') {
        this.fromAddress = this.get_editing_shipment.fromAddress;
        this.fromData = this.get_editing_shipment.fromData;
      }

      //set sender reference even if sender data is not set
      this.fromData.reference = this.get_editing_shipment.fromData.reference || this.get_user.shipper_reference;

      // Set PICKUP ADDRESS
      if (this.get_editing_shipment.isCustomSenderWaybill) {
        this.waybillAddress = this.get_editing_shipment.waybillAddress;
        this.waybillData = this.get_editing_shipment.waybillData;
      }

      if (this.get_editing_shipment.draftSubaccountId) {
        this.bookingSubaccount = this.get_editing_shipment.draftSubaccountId
      }

      // Flag is return shipment
      this.isReturn = this.get_editing_shipment.isReturn;
      this.editShipmentDroppointNo = this.get_editing_shipment.droppointNo;
      // Set customer - to
      this.toAddress = this.get_editing_shipment.toAddress;
      this.toData = this.get_editing_shipment.toData;

      // Set goods
      this.activeGoodsTypes = this.get_editing_shipment.activeGoodsTypes;
      this.$store.dispatch('GET_PARCEL_TYPES').then(() => {
      })

      //Remove connection with store
      //https://stackoverflow.com/questions/68774950/strange-console-log-output-with-vuex
      const packkages = _.cloneDeep(this.get_editing_shipment.storeShipmentPackages);

      //Set default user options if there is packaging
      const newPackages = [];
      const fallbackCurrency = (this.$store.getters.get_user && this.$store.getters.get_user.currency)
        ? String(this.$store.getters.get_user.currency).toLowerCase()
        : 'dkk';

      packkages.forEach((packk) => {
        if(packk.goodsType === 1 && !packk.parcelType) {
          packk.parcelType = this.get_user.parcel_package_id ?? null
        }
        if(packk.goodsType === 2 && !packk.parcelType) {
          packk.parcelType = this.get_user.document_package_id ?? null
        }
        if(packk.goodsType === 3 && !packk.palleteType) {
          packk.palleteType = this.get_user.pallet_package_id && parseInt(this.get_user.pallet_package_id) !== 5019 //'Pallet - unspecified'
            ? this.get_user.pallet_package_id
            : 5015 //'Euro pallet - 120cm x 80cm'
          packk.pallet_stackable_type = this.get_user.stackable || 'stackable'
        }
        if(packk.goodsType === 4 && !packk.parcelType) {
          packk.parcelType = this.get_user.load_package_id ?? null
        }

        // Respect existing content values when copying/editing.
        // Only fill missing currency units with user setting, or DKK if user has no currency.
        if (Array.isArray(packk.content)) {
          packk.content = packk.content.map((c) => {
            const content = { ...c };
            if (!content.unitValue) {
              content.unitValue = { value: content.unitValue?.value ?? 0, unit: fallbackCurrency };
            } else if (!content.unitValue.unit || String(content.unitValue.unit).trim() === '') {
              content.unitValue.unit = fallbackCurrency;
            }
            return content;
          });
        }

        newPackages.push(packk)
      })

      this.shipmentPackages = _.cloneDeep(newPackages)

      // Set customs - invoicing
      this.customsData.goods_incoterm = this.get_editing_shipment.customsData.goods_incoterm;
      this.customsData.duty_paid_by = this.get_editing_shipment.customsData.duty_paid_by;
      this.customsData.duty_payer_account_no = this.get_editing_shipment.customsData.duty_payer_account_no;
      this.customsData.freight_paid_by = this.get_editing_shipment.customsData.freight_paid_by;
      this.customsData.freight_payer_account_no = this.get_editing_shipment.customsData.freight_payer_account_no;
      this.customsData.freight_payer_id = this.get_editing_shipment.customsData.freight_payer_id;

      this.fromData.shipFromPrivateResident = (this.shipperType === 'private');
      this.toData.shipToPrivateResident = (this.receiverType === 'private');

      // custom tags
      this.custom_tag_json = this.get_editing_shipment.custom_tag_json;
      // For validation we must compare against the booking system defaults, not the edited values
      this.$store.dispatch('GET_BOOKING_SYSTEMS').then((res) => {
        if(res.items.length > 0){
          // Set the default template used for comparison in validation
          this.custom_tag_json_tmp = JSON.parse(JSON.stringify(res.items[0].custom_tag_json));
          this.isSenderReferenceRequired = res.items[0].is_shipper_reference_required;
          this.isReceiverReferenceRequired = res.items[0].is_receiver_reference_required;
          this.showColliAmount = res.items[0].show_booking_colli_amount;
          this.systemShowColliContent = res.items[0].show_booking_colli_content;
          this.showInfoBox = res.items[0].show_booking_info_box;
          this.isPhoneRequired = res.items[0].is_phone_required;
          this.isEmailRequired = res.items[0].is_email_required;
          this.senderHandlingType = parseInt(res.items[0].sender_handling_type)
        }
      });
      // services
      this.incotermServices = this.get_editing_shipment.apiIncotermSerivces;
      //Separate incoterm services and global services
      let apiFeeIds = [];

      this.get_editing_shipment.apiFeeIds.forEach((feeId) => {
        if (this.get_editing_shipment.apiIncotermSerivces.length) {
          this.get_editing_shipment.apiIncotermSerivces.forEach((incotermId) => {
            if (parseInt(incotermId) !== parseInt(feeId)) {
              apiFeeIds.push(feeId)
            }
          })
        } else {
          apiFeeIds.push(feeId)
        }
      })

      console.log('edit shipment fee ids ' + apiFeeIds)
      this.feeIdsJson = apiFeeIds;
      this.active_services_json = this.get_editing_shipment.apiActiveServices; //active_services_view
      this.selectedProduct = this.get_editing_shipment.selectedProduct;
      this.additionalServicesFieldsData = Object.keys(this.get_editing_shipment.additionalServicesData).length
        ? this.get_editing_shipment.additionalServicesData
        : {};
      this.pickupDriverNote = this.get_editing_shipment.pickupDriverNote;
      this.pickupTimeUntil = this.get_editing_shipment.pickupTimeUntil;
      this.pickupTimeFrom = this.get_editing_shipment.pickupTimeFrom;
      this.toWaybill = this.get_editing_shipment.isCustomSenderWaybill;
      this.invoiceType = this.get_editing_shipment.invoiceType;

      if (this.get_editing_shipment) {
        this.selectedInfoItems = []
        if (this.get_editing_shipment?.eccn) {
          this.eccn = this.get_editing_shipment.eccn
          this.selectedInfoItems.push(String(2))
        }
        if (this.get_editing_shipment?.eeiitn) {
          this.eeiitn = this.get_editing_shipment.eeiitn
          this.selectedInfoItems.push(String(3))
        }
        if (this.get_editing_shipment?.customsAdditionalInfoText) {
          this.customsAdditionalInfoText = this.get_editing_shipment.customsAdditionalInfoText
          this.selectedInfoItems.push(String(22))
        }
      }

      if(this.get_editing_shipment?.invoiceFiles) {
        this.invoiceFiles = this.get_editing_shipment.invoiceFiles
        this.customs_files = this.get_editing_shipment.invoiceFiles
      }

    } else {
      // SET SHIPPER OPTIONS
      this.cachedShipper = this.shipper;
      this.$store.dispatch('GET_SHIPPERS').then((res) => {
        this.shipperOptions = [
          {value: null, text: 'Other address', country: ''},
          ...res.filter((opt) => {
            const type = Array.isArray(opt.type) ? opt.type : (opt.type ? JSON.parse(opt.type) : []);
            const hasType1 = type.indexOf('1') !== -1 || type.indexOf(1) !== -1;
            const hasType2 = type.indexOf('2') !== -1 || type.indexOf(2) !== -1;
            return hasType1 || hasType2;
          }).map((opt) => {
            return {
              value: opt.id,
              country: opt.country_id ? this.getCountry(opt.country_id, 'alpha2') : '',
              text: `
                ${opt.company_name ? opt.company_name + ', ' : ''}
                ${opt.name ? opt.name + ', ' : ''}
                ${opt.address_1 ? opt.address_1 + ', ' : ''}
                ${opt.post_code ? opt.post_code + ', ' : ''}
                ${opt.city ? opt.city + ', ' : ''}
                ${opt.state ? opt.state + ', ' : ''}
                ${opt.country_id ? this.getCountry(opt.country_id, 'name') : ''}
              `
            };
          }),
        ];
        if(this.shipper !== '' && this.shipper !== null && this.shipper !== 'custom'){
          this.isShipperInFrom = true;
          this.changeAddress('from', {...res.filter(opt => opt.id === this.shipper)[0], typeOfAction: 'app'});
        }
        // Preselect receiver from user preferences if available
        if (this.get_user && 'receiver_id' in this.get_user && this.get_user.receiver_id !== undefined) {
          this.receiver = this.get_user.receiver_id;
          if (this.receiver !== '' && this.receiver !== null && this.receiver !== 'custom') {
            this.setReceiverData(this.receiver);
          }
        }
      });
      // SET PARCEL TYPES
      this.$store.dispatch('GET_PARCEL_TYPES');
      // SET TAGS
      this.$store.dispatch('GET_BOOKING_SYSTEMS').then((res) => {
        if(res.items.length > 0){
          this.custom_tag_json = res.items[0].custom_tag_json;
          this.custom_tag_json_tmp = JSON.parse(JSON.stringify(res.items[0].custom_tag_json));
          this.isSenderReferenceRequired = res.items[0].is_shipper_reference_required;
          this.isReceiverReferenceRequired = res.items[0].is_receiver_reference_required;
          this.showColliAmount = res.items[0].show_booking_colli_amount;
          this.systemShowColliContent = res.items[0].show_booking_colli_content;
          this.showInfoBox = res.items[0].show_booking_info_box;
          this.isPhoneRequired = res.items[0].is_phone_required;
          this.isEmailRequired = res.items[0].is_email_required;
          this.senderHandlingType = parseInt(res.items[0].sender_handling_type || 1)
        }
      });

      this.setShippingDate(this.getFirstFiveAvailableShippingDates[0].toFormat('yyyy-MM-dd'));

      // USE DATA FROM APPLICATION
      // Set reference
      this.fromData.reference = this.get_user.shipper_reference ?? '';
      this.toData.reference = this.get_user.receiver_reference ?? '';
      this.defaultPackageBlocks.parcel.description = this.get_user.description ?? '';

      // Set shipper
      this.shipper = this.get_user.sender_id;
      this.foreignShipper = this.shipper === null;
    }
    this.shipmentPopup = this.get_user.label_printer_id === null;
    this.show_has_temperature = this.get_user.show_has_temperature;
    this.show_dangerous_goods = this.get_user.show_dangerous_goods;
    this.show_other_shipper_address = this.get_user.show_other_shipper_address;
    this.show_freight_paid_by = this.get_user.show_freight_paid_by;
    this.show_incoterms = this.get_user.show_incoterms;
    this.book_permission_type = this.get_user.book_permission_type;
  },
  methods: {
    isBefore(date1, date2) {
      return date1 < date2;
    }
  },
}
